import { BnAction } from '../../common/bn-action';

class BinUpdateLocation extends BnAction {
  constructor() {
    super();
    this.actionname = 'update-location';
    this.successtext = 'Bin location has been updated.';
    this.errortext = 'Failed to update bin location.';
    this.submittext = 'Update';
  }
}

window.customElements.define('bin-update-location', BinUpdateLocation);
